var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BlogArchive',{attrs:{"kind":"tag"}})
}
var staticRenderFns = []

export { render, staticRenderFns }